import { Inject, Injectable } from '@angular/core'
import { GlobalVariables } from 'fortunebit-staffhub/src/libs'
import { CreateClaimPage } from 'desktop-app/src/app/eclaim/create-claim/create-claim.page'
import { ClassValidatorFormGroup } from 'ngx-reactive-form-class-validator'
import { ModalService } from '../../core/modal.service'
import { ExpenseClaimApi } from './eclaim-api'
import * as eclaimTypes from './typings/eclaim-api.typings' // Get everything for expense claim type
import { LoaderService } from '@desktop-common-comp/services/loader.service'
import { ExpenseClaim, ExpenseClaimDetail } from 'fortunebit-staffhub/src/model/expense_claim.model'
import { validate } from 'class-validator'
import { ToastService } from '@desktop-common-comp/services/toast.service'
import { Router } from '@angular/router'
import { ChangeDetectionService } from 'desktop-app/src/app/eclaim/shared/change-detection.service'
import { attachement } from 'fortunebit-staffhub/src/typings/common-api.typings'

/** The purpose of this script it to provide all the nessacary ExpenseClaim Functions without 
exposing underlying api's
Can carry out input and output validation on this script.
*/
@Injectable({
    providedIn: 'root'
})
export class ExpenseClaimCore {
    public expenseTypeList: any = []
    public vehicleLists: any[] = []
    public editClaimOnBehalf: any[] = []
    public editMealTypes: any[] = []
    public eclaimAmountCore: number
    public milageClaimLimit: number

    constructor(
        @Inject(ChangeDetectionService) private changeDetection: ChangeDetectionService,
        @Inject(ExpenseClaimApi) public ExpenseClaimApi: ExpenseClaimApi,
        @Inject(ModalService) private modalService: ModalService,
        @Inject(ExpenseClaimApi) private eclaimAPI: ExpenseClaimApi,
        @Inject(GlobalVariables) private global: GlobalVariables,
        @Inject(LoaderService) private loader: LoaderService,
        @Inject(ToastService) public toast: ToastService,
        @Inject(Router) private router: Router,
    ) {
        this.fetchNewExpenseList()
        this.fetchVehicleTyperMilageClaim()
    }


    // As of rite now we maintain the return type as promises
    getClaimList(args: eclaimTypes.InputClaimList): Promise<Array<eclaimTypes.ExpensesClaimData>> {
        // You can provide validation section before hiting the api calls 


        return new Promise((resolve, reject) => {
            this.ExpenseClaimApi.getClaimList(args).subscribe(
                res => { resolve(res) },
                err => { reject(err) } // Error can be handled here using rxjs operators or our own custom operators
            )
        })
    }


    modalEclaimCreate() {
        this.modalService.createComponentAppWide().then(compRef => {
            // console.log(compRef, 'compRef');
            compRef.instance.title = "Add Expenses"
            compRef.instance.component = CreateClaimPage
            compRef.instance.size = 'full'
            compRef.instance.dismiss.subscribe(data => {
                compRef.destroy()
                compRef.changeDetectorRef.detectChanges()
            })
            setTimeout(() => {
                compRef.changeDetectorRef.detectChanges()
            }, 150)
            compRef.instance.submitted.subscribe(data => {
                compRef.destroy()
                this.changeDetection.triggerClaimList()
                compRef.changeDetectorRef.detectChanges()
            })
        })
    }


    getFromToList() {
        return [
            { "location": "Manjung Office", "distance": 321 },
            { "location": "Ayer Tawar", "distance": 100 },
            { "location": "Perak Tengah", "distance": 150 },
            { "location": "Seri Iskandar", "distance": 200 },
            { "location": "Batu Gajah", "distance": 100 },
            { "location": "Station 18", "distance": 76 },
            { "location": "Ipoh", "distance": 80 },
            { "location": "Bukit Mertajam", "distance": 45 },
            { "location": "Penang", "distance": 87 },
            { "location": "KL Office", "distance": 95 },
            { "location": "Bukit Bintang", "distance": 23 },
            { "location": "Shah Alam", "distance": 45 },
            { "location": "Cheras", "distance": 78 },
            { "location": "Ampang", "distance": 98 },
            { "location": "Putrajaya", "distance": 23 },
            { "location": "Senawang", "distance": 87 },
            { "location": "Teluk Intan", "distance": 23 },
            { "location": "Taiping", "distance": 56 },
            { "location": "Others", "distance": 78 }
        ]
    }


    determineMileageDistance(form: ClassValidatorFormGroup) {
        // Assume validation of milleage already happened
        if (form.controls['mileage_to'].value != 'Others' && form.controls['mileage_from'].value != 'Others') {
            this.eclaimAPI.getMillageAmount({
                company: this.global.user_global.company,
                employee: this.global.user_global.employee_id,
                from_distance: form.controls['mileage_from'].value,
                return_trip: form.controls['mileage_return'].value,
                vehicle_type: form.controls['vehicle_type'].value,
                to_distance: form.controls['mileage_to'].value,
            }).subscribe(data => {
                // this.milageClaimLimit = data['message'].final_claim_amount
                form.patchValue({
                    mileage_description: `${form.controls['mileage_from'].value} \n ${form.controls['mileage_to'].value}`,
                    mileage_from: form.controls['mileage_from'].value,
                    mileage_to: form.controls['mileage_to'].value,
                    amount: Number.isInteger(data['message'].final_claim_amount) ? data['message'].final_claim_amount : (data['message'].final_claim_amount).toFixed(3),
                    mileage_distance: data['message'].total_distance,
                    transport_allowance: data['message'].total_allowance,
                    deducted_transport_allowance: data['message'].total_consumed_on_doc
                }, { emitEvent: false })
            })
        }
    }

    async determineOtherMileageDistance(form: ClassValidatorFormGroup, update_vehicle: boolean) {
        // Assume validation of milleage already happened
        if (form.controls['mileage_to'].value == 'Others' || form.controls['mileage_from'].value == 'Others') {
            this.eclaimAPI.getMillageOtherAmount({
                total_distance: form.controls.mileage_distance.value,
                company: this.global.user_global.company,
                employee: this.global.user_global.employee_id,
                vehicle_type: form.controls.vehicle_type.value,
                return_trip: form.controls.mileage_return.value,
                update_vehicle: update_vehicle
            }).subscribe(data => {
                // console.log({ data });
                // this.milageClaimLimit = data['message'].final_claim_amount
                form.patchValue({
                    mileage_description: ` ${form.controls.mileage_from.value} \n ${form.controls.mileage_to.value}`,
                    mileage_from: form.controls.mileage_from.value,
                    mileage_to: form.controls.mileage_to.value,
                    amount: Number.isInteger(data['message'].final_claim_amount) ? data['message'].final_claim_amount : (data['message'].final_claim_amount).toFixed(3),
                    mileage_distance: data['message'].total_distance,
                    transport_allowance: data['message'].total_allowance,
                    deducted_transport_allowance: data['message'].total_consumed_on_doc
                }, { emitEvent: false })
            })
        }
    }

    async fetchNewExpenseList() {
        return new Promise((resolve, reject) => {
            this.eclaimAPI.getNewExpenseTypeList().subscribe(data => {
                if (data.code == 200) {
                    this.expenseTypeList = data['message']
                    // console.log(this.expenseTypeList, 'this.expenseTypeList');
                    resolve(true)
                } else {
                    this.expenseTypeList = []
                    resolve(false)
                }
            })
        })
    }

    async submitClaim(form: ClassValidatorFormGroup, attachement: attachement | null = null) {
        return new Promise(async (resolve, reject) => {
            // console.log({ form });
            await this.loader.presentGlobalLoading()
            let parent_expense = new ExpenseClaim()
            let new_expense = new ExpenseClaimDetail()

            Object.assign(new_expense, form)
            // console.log(expense_on_behalf)
            parent_expense.employee = this.global.user_global.employee_id

            new_expense.amount = form['amount'] === null || form['amount'] === undefined || form['amount'] === '' ? this.eclaimAmountCore : form['amount']
            new_expense.disclaimed_transport_allowance = new_expense.transport_allowance
            new_expense.claim_on_behalf = new_expense.claim_on_behalf && new_expense.claim_on_behalf.length > 0 ? new_expense.claim_on_behalf.map((claimOnBehalf) => ({
                name: null,
                employee: claimOnBehalf.value,
                employee_name: claimOnBehalf.description
            })) : []

            new_expense.meal_types = new_expense.meal_types && new_expense.meal_types.length > 0 ? new_expense.meal_types.map((mealTypes) => ({
                name: null,
                meal_type: mealTypes
            })) : []
            parent_expense.expenses = [new_expense]
            parent_expense.from_server = 'New App Server'

            // console.log(parent_expense, 'claim_on_behalf');

            await validate(parent_expense).then(async (data) => {
                // Validated
            }).catch(error => {
                // Unvalidated
                console.log(error)
            })



            await this.eclaimAPI.createExpenseClaim(parent_expense).subscribe({
                next: (data) => {
                    this.toast.successToast('Succesfully Create Claim', 'success')
                    this.loader.hideGlobalLoading()
                    resolve(data)
                },
                complete: () => { console.log('completed submitClaim') },
                error: (error) => {
                    console.log(error);
                    this.toast.errorToast(error?.error?.message, 'Error')
                    this.loader.hideGlobalLoading()
                    reject(error)
                }
            })
        })
    }


    async updateClaim(form: ClassValidatorFormGroup, child_doc: ExpenseClaimDetail, parent_doc_name: string, attachement: attachement | null = null, expenseType: any) {
        return new Promise(async (resolve, reject) => {
            await this.loader.presentGlobalLoading()
            let parent_doc = new ExpenseClaim()
            // console.log(form, 'form');
            if (form['claim_on_behalf'] && form['claim_on_behalf'].length > 0) {
                const existingClaimOnBehalfList = this.editClaimOnBehalf.filter(claimOnBehalf => form['claim_on_behalf'].some(item => claimOnBehalf.employee === item.value)).map((filterItem) => ({
                    name: filterItem.name,
                    employee: filterItem.employee,
                    employee_name: filterItem.employee_name,
                }));
                const newClaimOnBehalfList = form['claim_on_behalf'].filter(claimOnBehalf => !this.editClaimOnBehalf.some(item => claimOnBehalf.value === item.employee)).map((newItem) => ({
                    name: null,
                    employee: newItem.value,
                    employee_name: newItem.description,
                }));
                parent_doc.claim_on_behalf = [...newClaimOnBehalfList, ...existingClaimOnBehalfList]
            }

            if (form['meal_types'] && form['meal_types'].length > 0) {
                const existingMealTypeList = this.editMealTypes.filter(mealType => form['meal_types'].some(item => mealType.meal_type === item)).map((filterItem) => ({
                    name: filterItem.name,
                    meal_type: filterItem.meal_type,
                }));
                const newMealTypeList = form['meal_types'].filter(mealType => !this.editMealTypes.some(item => mealType === item.meal_type)).map((newItem) => ({
                    name: null,
                    meal_type: newItem,
                }));
                parent_doc.meal_types = [...newMealTypeList, ...existingMealTypeList]
            }


            // // Merge value's from form to class
            Object.assign(child_doc, form)

            // child_doc.attachment = null
            parent_doc.action = 'Update'
            child_doc.action = 'Update'
            child_doc.expense_type = expenseType
            parent_doc.name = parent_doc_name
            parent_doc.expenses = [child_doc]
            parent_doc.action = 'Update'
            parent_doc.expenses[0].amount = form['amount'] === null || form['amount'] === undefined || form['amount'] === '' ? this.eclaimAmountCore : form['amount']
            // console.log({ parent_doc });

            await this.eclaimAPI.updateExpenseClaim(parent_doc).subscribe({
                next: (data) => {
                    this.toast.successToast('Claim Succesfully Updated', 'success')
                    this.loader.hideGlobalLoading()
                    this.editClaimOnBehalf = []
                    this.editMealTypes = []
                    resolve(true)
                },
                complete: () => { console.log('completed updateClaim') },
                error: (error) => {
                    console.log(error)
                    this.editClaimOnBehalf = []
                    this.toast.errorToast(error?.error?.message, 'Error')
                    this.loader.hideGlobalLoading()
                    reject(error)
                }
            })
        })

    }

    upload_attachement(attachement: attachement, docname: string) {
        return new Promise(async (resolve, reject) => {
            // console.log(attachement)
            // console.log(docname)
            await this.loader.presentGlobalLoading()
            const formData = new FormData();
            formData.append('file', attachement.source);
            formData.append('doctype', 'Expense Claim');
            formData.append('docname', `New Expense Claim ${Math.random().toString(36).slice(2)}`);

            await this.eclaimAPI.ext_uploadClaim(formData).subscribe({
                next: (data) => {
                    this.toast.successToast('Attachement Uploaded Succesfully', 'success')
                    this.loader.hideGlobalLoading()
                    resolve(data)
                },
                complete: () => { console.log('completed upload_attachement') },
                error: (error) => {
                    console.log(error)
                    this.toast.errorToast(error?.error?.message, 'Error')
                    this.loader.hideGlobalLoading()
                    reject(error)
                }
            })
        })
    }

    delete_attachment(attachement: attachement, docname: string) {
        return new Promise(async (resolve, reject) => {
            // let load = await this.loader.presentLoading('Deleting Attachment')
            await this.eclaimAPI.ext_deleteExpenseClaimAttachment({
                'attachement': attachement,
                'docname': docname
            }).subscribe({
                next: (data) => {
                    this.toast.successToast('Attachement Deleted Succesfully', 'success')
                    // load.dismiss()
                    resolve(true)
                },
                complete: () => { console.log('completed delete_attachment') },
                error: (error) => {
                    this.toast.errorToast(error?.error?.message, 'Error')
                    // load.dismiss()
                    reject(error)
                }
            })
        })
    }

    getVehicleType() {
        return new Promise<any>(async (resolve, reject) => {
            await this.eclaimAPI.getVehicleType({
                company: this.global?.user_global?.company
            }).subscribe({
                next: (data) => {
                    resolve(data)
                },
                complete: () => { console.log('completed getVehicleType') },
                error: (error => {
                    reject(error)
                })
            })
        })
    }

    fetchVehicleTyperMilageClaim() {
        this.getVehicleType().then((data) => {
            // console.log({ data });
            if (data['code'] === 200) {
                this.vehicleLists = data['message']
            }
        })
    }

}